import { IconCallOut } from '../../../icons/IconCallOut';
import { BodyText } from '../../../typography/BodyText';

export type CallOutProps = {
  title: string;
  content: string;
};

export const CallOutModule = ({ title, content }: CallOutProps) => {
  return (
    <div className="bg-background-primary-faded mb-10 mt-6 flex flex-col p-4" data-testid="callout">
      <div className="mb-4 flex items-center">
        <IconCallOut />
        <h3
          className="text-neutral-strong font-inter m-0 ml-2 text-base font-semibold leading-none"
          data-testid="callout-title"
        >
          {title}
        </h3>
      </div>
      <BodyText leading="relaxed" color="grey.700">
        {content}
      </BodyText>
    </div>
  );
};
